var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hwid"},[_c('div',[_vm._v("Информация об устройстве")]),_c('div',[_c('sub',[_c('strong',[_vm._v("Fingerprint:")]),_vm._v(" "+_vm._s(_vm.hwid))])]),_c('div',[_c('sub',[_c('strong',[_vm._v("ОС и Браузер:")]),_vm._v(" "+_vm._s(_vm.deviceName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }